import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import type {BadgesData} from '@/types/loyalty';

type LoyaltyState = {
    badgesData: BadgesData | null;
};

const initialState: LoyaltyState = {
    badgesData: null,
};

export const slice = createSlice({
    name: 'loyalty',
    initialState,
    reducers: {
        setBadgesData: (state, action: PayloadAction<BadgesData>) => {
            return {...state, badgesData: action.payload};
        },
    },
});

export const {setBadgesData} = slice.actions;
export default slice.reducer;
